import React from 'react'
import { useState } from 'react'
import { RadioGroup } from '@headlessui/react'
import { CheckCircleIcon, TrashIcon } from '@heroicons/react/20/solid'

const position = [
  { id: 1, title: 'BUY' },
  { id: 0, title: 'SELL' },
]

const bestBuyOffer = [
  { id: 1, price: 0.2, contracts: 20 },
]

const bestSellOffer = [
  { id: 1, price: 0.4, contracts: 30 },
]

const buyOdds = [
  { id: 1, 0.1: '9/1', 0.2: '4/1', 0.3: '7/3', 0.4: '3/2', 0.5: 'Even', 0.6: '2/3', 0.7: '3/7', 0.8: '1/4', 0.9: '1/9' }
]

const sellOdds = [
  { id: 1, 0.1: '1/9', 0.2: '1/4', 0.3: '3/7', 0.4: '2/3', 0.5: 'Even', 0.6: '3/2', 0.7: '7/3', 0.8: '4/1', 0.9: '9/1' }
]

function setPrice(totalPrice){
  return totalPrice
}

const egPrinciple = 'lqf4c-fnf4w-5ba5m-rv6xq-hrqif-33q2g-vyaza-msion-kfi4w-kwwof-feq'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Example(props) {

  const bestOfferPremium = bestBuyOffer[0].price

  const [selectedPosition, setSelectedPosition] = useState(position[0])

  const [counterOffer, setCounterOffer] = useState(false)
  const initialNumberOfContracts = 1
  const [numberOfContracts, setNumberofContracts] = useState(initialNumberOfContracts)
  const initialValues = { numberOfContracts: numberOfContracts, premium: bestOfferPremium }
  const [formValues, setFormValues] = useState(initialValues)
  const [isSubmit, setSubmit] = useState(false)
  var totalPrice

  var order
  if (props.market === props.home || props.market === 'DRAW') {
    order = { userID: egPrinciple, gameID: props.gameID, market: props.market, book: props.book, position: selectedPosition.title, numberOfContracts: formValues.numberOfContracts, premium: formValues.premium }
  }
  if (props.market === props.away) {
    order = { userID: egPrinciple, gameID: props.gameID, market: props.market, book: props.book, position: position[selectedPosition.id].title, numberOfContracts: formValues.numberOfContracts, premium: (1 - formValues.premium).toFixed(1) }
  }

  var message
  if (props.book === 'DRAW' && selectedPosition.title === 'BUY') {
    message = 'I think it will be a draw'
  }
  if (props.book === 'DRAW' && selectedPosition.title === 'SELL') {
    message = "I think it won't be a draw"
  }
  if (props.book != 'DRAW' && selectedPosition.title === 'BUY') {
    message = ['I think ', props.market, ' wins']
  }
  if (props.book != 'DRAW' && selectedPosition.title === 'SELL') {
    message = ['I think ', props.market, ' loses']
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormValues({ ...formValues, [name]: value })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setSubmit(true)
  }

  const setSellWindow = (e) => {
    resetCounterOffer()
    setSelectedPosition(position[1])
    setFormValues({ ...formValues, position: position[1].title, premium: bestSellOffer[0].price })
  }

  const setBuyWindow = (e) => {
    resetCounterOffer()
    setSelectedPosition(position[0])
    setFormValues({ ...formValues, position: position[0].title, premium: bestBuyOffer[0].price })
  }

  const toggleCounterOffer = () => {
    setCounterOffer(true)
    if (selectedPosition === position[0]) {
      setFormValues({ ...formValues, position: selectedPosition.title, numberOfContracts: initialNumberOfContracts, premium: bestBuyOffer[0].price })
    }
    else {
      setFormValues({ ...formValues, position: selectedPosition.title, numberOfContracts: initialNumberOfContracts, premium: bestSellOffer[0].price })
    }
  }

  const resetCounterOffer = () => {
    setCounterOffer(false)
    if (selectedPosition === position[0]) {
      setFormValues({ ...formValues, position: selectedPosition.title, numberOfContracts: initialNumberOfContracts, premium: bestBuyOffer[0].price })
    }
    else {
      setFormValues({ ...formValues, position: selectedPosition.title, numberOfContracts: initialNumberOfContracts, premium: bestSellOffer[0].price })
    }
  }

  async function startPayment(el) {
    el.target.disabled = true; 
    const transferAmount = (totalPrice * 1_000_000_00)
    const address = "h4tse-dl33g-z76wk-sjw4l-tnayn-obkh6-llwbu-zvasp-mnrt5-474ph-5qe";
    console.log(transferAmount)
  
    const hasAllowed = await window.ic.plug.requestConnect();
  
    if (hasAllowed) {
      el.target.textContent = "Plug wallet is connected";
  
      const requestBalanceResponse = await window.ic.plug.requestBalance()
      
      const balance = (requestBalanceResponse[0].amount) * 1_000_000_00
  
      if (balance >= transferAmount) {
        const requestTransferArg = {
          to: address,
          amount: transferAmount,
        };
        const transfer = await window.ic.plug.requestTransfer(requestTransferArg);
        const transferStatus = transfer.transactions.transactions[0].status;
        console.log(transfer)

        if (transferStatus === 'COMPLETED') {
          el.target.textContent = `Plug wallet transferred ${transferAmount} e8s`;
        } else if (transferStatus === 'PENDING') {
          el.target.textContent = "Plug wallet is pending.";
        } else {
          el.target.textContent = "Plug wallet failed to transfer";
        }
      } else {
        el.target.textContent = "Plug wallet doesn't have enough balance";
      }
    } else {
      el.target.textContent = "Plug wallet connection was refused";
    }
  
    setTimeout(function () {
      el.target.disabled = false;
    }, 1000);
  
  }

  function buttons(totalPrice) {
    if (window.innerWidth < 1024) {
      return (
        <div>
          <div className="grid grid-cols-2 px-2 gap-4 pt-2">
            <button
              type="submit"
              
              className="rounded-md border border-transparent justify-center bg-green-500 py-3 px-4 text-base font-medium text-white shadow-sm hover:bg-green-600"
            >
              ACCEPT
            </button>
            <button onClick={toggleCounterOffer} className="text-center rounded-md border border-transparent bg-red-600 py-3 text-base font-medium text-white shadow-sm hover:bg-red-700"
            >
              COUNTER
            </button>
          </div>
        </div>
      )
    }
    else {
      return (
        <div>
          <div className="py-2 px-6">
            <button
              type="submit"
              
              className="w-full rounded-md border border-transparent bg-green-500 py-3 px-4 text-base font-medium text-white shadow-sm hover:bg-green-600"
            >
              ACCEPT
            </button>
          </div>
          <div className='py-2 px-6 border-t border-gray-300'>
            <button onClick={toggleCounterOffer} className="w-full text-center rounded-md border border-transparent bg-red-600 py-3 px-4 text-base font-medium text-white shadow-sm hover:bg-red-700"
            >
              COUNTER OFFER
            </button>
          </div>
        </div>
      )
    }
  }

  // buy window
  if (selectedPosition === position[0] && !counterOffer) {
    totalPrice = ((formValues.numberOfContracts * 0.02) + (formValues.numberOfContracts * formValues.premium)).toFixed(2)
    return (
      <div className="bg-gray-100 rounded-lg">
        {/* <pre className='text-black'>{JSON.stringify(order, undefined, 2)}</pre> */}
        <div className="mx-auto max-w-2xl px-2 pt-1 sm:px-6 lg:max-w-7xl lg:px-8 divide-y divide-gray-300">
          <h1 className="text-2xl text-center font-bold pb-2 text-gray-900">Place your bets!</h1>
          <div>
            <RadioGroup value={selectedPosition} onChange={setSellWindow}>
              <div className="pt-4 grid gap-y-6 grid-cols-2 gap-x-4">
                {position.map((position) => (
                  <RadioGroup.Option
                    key={position.id}
                    value={position}
                    className={({ checked, active }) =>
                      classNames(
                        checked ? 'border-transparent bg-gradient-to-br from-purple-600 to-orange-300' : 'border-gray-300',
                        active ? 'ring-2 ring-black' : '',
                        'relative flex cursor-pointer rounded-lg border bg-white p-4 shadow-sm focus:outline-none'
                      )
                    }
                  >
                    {({ checked, active }) => (
                      <>
                        <span className="flex-1">
                          <span className="flex flex-col">
                            <RadioGroup.Label as="span" className="block text-sm  text-gray-900 font-bold">
                              {position.title}
                            </RadioGroup.Label>
                          </span>
                        </span>
                        {checked ? <CheckCircleIcon className="h-5 w-5 text-black" aria-hidden="true" /> : null}
                        <span
                          className={classNames(
                            active ? 'border' : 'border-2',
                            checked ? 'border-black' : 'border-transparent',
                            'pointer-events-none absolute -inset-px rounded-lg'
                          )}
                          aria-hidden="true"
                        />
                      </>
                    )}
                  </RadioGroup.Option>
                ))}
              </div>
            </RadioGroup>
            <h2 className="text-lg py-2 text-center font-medium text-gray-900">"{message}"</h2>
          </div>
          <div className='pb-1'>
            <h3 className="pt-2 font-medium text-gray-900">Best offer available:</h3>
            <div className="grid gap-y-6 grid-cols-2">
              <div>
                <div className="overflow-hidden rounded-lg px-4">
                  <dt className="truncate text-m font-medium text-gray-500">Premium
                    <output className="px-2 mt-1 text-xl font-semibold text-gray-900">
                      {bestBuyOffer[0].price} ICP
                    </output>
                  </dt>
                </div>
              </div>
              <div>
                {buyOdds.map(odds => {
                  return (
                    <h3 key={odds.id} className="text-center text-m font-medium text-gray-900"><em>Implied Odds = {odds[formValues.premium]}</em></h3>
                  )
                })
                }
              </div>
            </div>
            <div className="overflow-hidden rounded-lg px-4 pb-2">
              <dt className="truncate text-m font-medium text-gray-500">Available Contracts
                <output className="px-2 text-xl font-semibold text-gray-900">
                  {bestBuyOffer[0].contracts}
                </output>
              </dt>
            </div>
          </div>
          <form>
            <div>
              <div className="pt-4 grid grid-cols-2 items-center">
                <label htmlFor="numberOfContracts" className="text-left block text-m font-medium text-gray-700">
                  Number of Contracts
                </label>
                <div>
                  <div className="flex w-auto rounded-md shadow-sm">
                    <input
                      type="number"
                      defaultValue={formValues.numberOfContracts}
                      step="1"
                      pattern="/d+"
                      min="1"
                      max={bestBuyOffer[0].contracts}
                      name="numberOfContracts"
                      id="buycontracts"
                      required="required"
                      onChange={handleChange}
                      className="block w-auto min-w-0 flex-1 bg-white text-center text-black font-bold rounded-md  border-black ring-indigo-500 sm:text-sm"
                    />
                  </div>
                </div>

              </div>
              <div className="items-center sm:border-gray-200">
                {bestBuyOffer.map((offer) => (
                  <div key={offer.id} className='w-max'>
                    <h3 className="pt-2 text-m font-medium text-gray-900"><em>Potential Profit = {(formValues.numberOfContracts * (1 - formValues.premium)).toFixed(2)} ICP</em></h3>
                    <h3 className="pb-4 text-m font-medium text-gray-900"><em>Total Price = {((formValues.numberOfContracts * formValues.premium) + (formValues.numberOfContracts * 0.02)).toFixed(2)} ICP</em></h3>
                  </div>
                ))}
              </div>
            </div>
          </form>
          {buttons()}
        </div>
      </div>
    )
  }

  //counter buy window
  if (selectedPosition === position[0] && counterOffer) {
    totalPrice = ((formValues.numberOfContracts * 0.02) + (formValues.numberOfContracts * formValues.premium)).toFixed(2)
    return (
      <div className="bg-gray-100 rounded-lg">
        {/* <pre className='text-black'>{JSON.stringify(order, undefined, 2)}</pre> */}
        <div className="mx-auto max-w-2xl px-2 pt-1 sm:px-6 lg:max-w-7xl lg:px-8 divide-y divide-gray-300">
          <h1 className="text-2xl text-center font-bold pb-2 text-gray-900">Place your bets!</h1>
          <div>
            <RadioGroup value={selectedPosition} onChange={setSellWindow}>
              <div className="pt-4 grid gap-y-6 grid-cols-2 gap-x-4">
                {position.map((position) => (
                  <RadioGroup.Option
                    key={position.id}
                    value={position}
                    className={({ checked, active }) =>
                      classNames(
                        checked ? 'border-transparent bg-gradient-to-br from-purple-600 to-orange-300' : 'border-gray-300',
                        active ? 'ring-2 ring-black' : '',
                        'relative flex cursor-pointer rounded-lg border bg-white p-4 shadow-sm focus:outline-none'
                      )
                    }
                  >
                    {({ checked, active }) => (
                      <>
                        <span className="flex flex-1">
                          <span className="flex flex-col">
                            <RadioGroup.Label as="span" className="block text-sm  text-gray-900 font-bold">
                              {position.title}
                            </RadioGroup.Label>
                          </span>
                        </span>
                        {checked ? <CheckCircleIcon className="h-5 w-5 text-black" aria-hidden="true" /> : null}
                        <span
                          className={classNames(
                            active ? 'border' : 'border-2',
                            checked ? 'border-black' : 'border-transparent',
                            'pointer-events-none absolute -inset-px rounded-lg'
                          )}
                          aria-hidden="true"
                        />
                      </>
                    )}
                  </RadioGroup.Option>
                ))}
              </div>
            </RadioGroup>
            <h2 className="text-lg py-2 text-center font-medium text-gray-900">"{message}"</h2>
          </div>
          <div>
            <button onClick={resetCounterOffer} className="pb-2 pt-2 font-medium text-gray-700 hover:text-purple-600">
              <span className='text-xl pr-1 align-middle' aria-hidden="true"> &lArr; Best Offer Available</span>
            </button>
          </div>
          <form>
            <div>
              <h1 className='text-gray-700 font-bold text-center pt-2'>Counter Bid</h1>
              <div className="py-1 grid grid-cols-2 items-center">
                <label htmlFor="counter-price" className="text-left block text-m font-medium text-gray-700">
                  Premium
                </label>
                <div>
                  <div className="flex w-auto rounded-md shadow-sm">
                    <input
                      type="number"
                      defaultValue={bestBuyOffer[0].price}
                      step="0.1"
                      pattern="/d+"
                      min="0.1"
                      max="0.9"
                      name="premium"
                      id="counter-price"
                      required="required"
                      onChange={handleChange}
                      className="block w-auto min-w-0 flex-1 bg-white text-center text-black font-bold rounded-md  border-black ring-indigo-500 sm:text-sm"
                    />
                  </div>
                </div>
                <label htmlFor="numberOfContracts" className="pt-1 text-left block text-m font-medium text-gray-700">
                  Number of Contracts
                </label>
                <div>
                  <div className="flex w-auto rounded-md shadow-sm">
                    <input
                      type="number"
                      defaultValue="1"
                      step="1"
                      pattern="/d+"
                      min="1"
                      name="numberOfContracts"
                      id="counterbuycontracts"
                      required="required"
                      onChange={handleChange}
                      className="block w-auto min-w-0 flex-1 bg-white text-center text-black font-bold rounded-md  border-black ring-indigo-500 sm:text-sm"
                    />
                  </div>
                </div>
              </div>
              <div className="border-gray-200">
                <div className='w-max'>
                  {buyOdds.map(odds => {
                    return (
                      <h3 key={odds.id} className="pt-2 text-m font-medium text-gray-900"><em>Implied Odds = {odds[formValues.premium]}</em></h3>
                    )
                  })}
                  <h3 className="text-m font-medium text-gray-900"><em>Potential Profit = {(formValues.numberOfContracts * (1 - formValues.premium)).toFixed(2)} ICP</em></h3>
                  <h3 className="pb-2 text-m font-medium text-gray-900"><em>Total Price = {totalPrice} ICP</em></h3>
                </div>
              </div>
            </div>
          </form>
          <div className="py-4 px-6">
            <button
              type="submit"
              
              className="w-full rounded-md border border-transparent bg-green-500 py-3 px-4 text-base font-medium text-white shadow-sm hover:bg-green-600"
            >
              LOCK IN COUNTER
            </button>
          </div>
        </div>
      </div>
    )
  }

  //sell window
  if (selectedPosition === position[1] && !counterOffer) {
    totalPrice = (formValues.numberOfContracts * (1.02 - formValues.premium)).toFixed(2)
    return (
      <div className="bg-gray-100 rounded-lg">
        {/* <pre className='text-black'>{JSON.stringify(order, undefined, 2)}</pre> */}
        <div className="mx-auto max-w-2xl px-2 pt-1 sm:px-6 lg:max-w-7xl lg:px-8 divide-y divide-gray-300">
          <h1 className="text-2xl text-center font-bold pb-2 text-gray-900">Place your bets!</h1>
          <div>
            <RadioGroup value={selectedPosition} onChange={setBuyWindow}>
              <div className="pt-4 grid gap-y-6 grid-cols-2 gap-x-4">
                {position.map((position) => (
                  <RadioGroup.Option
                    key={position.id}
                    value={position}
                    className={({ checked, active }) =>
                      classNames(
                        checked ? 'border-transparent bg-gradient-to-br from-purple-600 to-orange-300' : 'border-gray-300',
                        active ? 'ring-2 ring-black' : '',
                        'relative flex cursor-pointer rounded-lg border bg-white p-4 shadow-sm focus:outline-none'
                      )
                    }
                  >
                    {({ checked, active }) => (
                      <>
                        <span className="flex flex-1">
                          <span className="flex flex-col">
                            <RadioGroup.Label as="span" className="block text-sm  text-gray-900 font-bold">
                              {position.title}
                            </RadioGroup.Label>
                          </span>
                        </span>
                        {checked ? <CheckCircleIcon className="h-5 w-5 text-black" aria-hidden="true" /> : null}
                        <span
                          className={classNames(
                            active ? 'border' : 'border-2',
                            checked ? 'border-black' : 'border-transparent',
                            'pointer-events-none absolute -inset-px rounded-lg'
                          )}
                          aria-hidden="true"
                        />
                      </>
                    )}
                  </RadioGroup.Option>
                ))}
              </div>
            </RadioGroup>
            <h2 className="text-lg py-2 text-center font-medium text-gray-900">"{message}"</h2>
          </div>
          <div className='pb-1'>
            <h3 className="pt-2 font-medium text-gray-900">Best offer available:</h3>
            <div className="grid gap-y-6 grid-cols-2">
              <div>
                <div className="overflow-hidden rounded-lg px-4">
                  <dt className="truncate text-m font-medium text-gray-500">Premium
                    <output className="px-2 mt-1 text-xl font-semibold text-gray-900">
                      {bestSellOffer[0].price} ICP
                    </output>
                  </dt>
                </div>
              </div>
              <div>
                {sellOdds.map(odds => {
                  return (
                    <h3 key={odds.id} className="text-center text-m font-medium text-gray-900"><em>Implied Odds = {odds[formValues.premium]}</em></h3>
                  )
                })
                }
              </div>
            </div>
            <div className="overflow-hidden rounded-lg px-4 pb-2">
              <dt className="truncate text-m font-medium text-gray-500">Available Contracts
                <output className="px-2 text-xl font-semibold text-gray-900">
                  {bestSellOffer[0].contracts}
                </output>
              </dt>
            </div>
          </div>
          <form>
            <div>
              <div className="pt-4 grid grid-cols-2 items-center">
                <label htmlFor="numberOfContracts" className="text-left block text-m font-medium text-gray-700">
                  Number of Contracts
                </label>
                <div>
                  <div className="flex w-auto rounded-md shadow-sm">
                    <input
                      type="number"
                      defaultValue={formValues.numberOfContracts}
                      step="1"
                      pattern="/d+"
                      min="1"
                      max={bestSellOffer[0].contracts}
                      name="numberOfContracts"
                      id="sellcontracts"
                      required="required"
                      onChange={handleChange}
                      className="block w-auto min-w-0 flex-1 bg-white text-center text-black font-bold rounded-md  border-black ring-indigo-500 sm:text-sm"
                    />
                  </div>
                </div>
              </div>
              <div className="items-center border-gray-200">
                <div className='w-max'>
                  <h3 className="pt-2 text-m font-medium text-gray-900"><em>Potential Profit = {((formValues.numberOfContracts * formValues.premium)).toFixed(2)} ICP</em></h3>
                  <h3 className="pb-4 text-m font-medium text-gray-900"><em>Implied Lockup = {totalPrice} ICP</em></h3>
                </div>
              </div>
            </div>
          </form>
          {buttons()}
        </div>
      </div>
    )
  }

  //counter sell window
  if (selectedPosition === position[1] && counterOffer) {
    totalPrice = ((formValues.numberOfContracts * (1.02 - formValues.premium)).toFixed(2))
    return (
      <div className="bg-gray-100 rounded-lg">
        {/* <pre className='text-black'>{JSON.stringify(order, undefined, 2)}</pre> */}
        <div className="mx-auto max-w-2xl px-2 pt-1 sm:px-6 lg:max-w-7xl lg:px-8 divide-y divide-gray-300">
          <h1 className="text-2xl text-center font-bold pb-2 text-gray-900">Place your bets!</h1>
          <div>
            <RadioGroup value={selectedPosition} onChange={setBuyWindow}>
              <div className="pt-4 grid gap-y-6 grid-cols-2 gap-x-4">
                {position.map((deliveryMethod) => (
                  <RadioGroup.Option
                    key={deliveryMethod.id}
                    value={deliveryMethod}
                    className={({ checked, active }) =>
                      classNames(
                        checked ? 'border-transparent bg-gradient-to-br from-purple-600 to-orange-300' : 'border-gray-300',
                        active ? 'ring-2 ring-black' : '',
                        'relative flex cursor-pointer rounded-lg border bg-white p-4 shadow-sm focus:outline-none'
                      )
                    }
                  >
                    {({ checked, active }) => (
                      <>
                        <span className="flex flex-1">
                          <span className="flex flex-col">
                            <RadioGroup.Label as="span" className="block text-sm  text-gray-900 font-bold">
                              {deliveryMethod.title}
                            </RadioGroup.Label>
                          </span>
                        </span>
                        {checked ? <CheckCircleIcon className="h-5 w-5 text-black" aria-hidden="true" /> : null}
                        <span
                          className={classNames(
                            active ? 'border' : 'border-2',
                            checked ? 'border-black' : 'border-transparent',
                            'pointer-events-none absolute -inset-px rounded-lg'
                          )}
                          aria-hidden="true"
                        />
                      </>
                    )}
                  </RadioGroup.Option>
                ))}
              </div>
            </RadioGroup>
            <h2 className="text-lg py-2 text-center font-medium text-gray-900">"{message}"</h2>
          </div>
          <div>
            <button onClick={resetCounterOffer} className="pb-2 pt-2 font-medium text-gray-700 hover:text-purple-600">
              <span className='text-xl pr-1 align-middle' aria-hidden="true"> &lArr; Best Offer Available</span>
            </button>
          </div>
          <form>
            <div>
              <h1 className='text-gray-700 font-bold text-center pt-2'>Counter Ask</h1>
              <div className="py-1 grid grid-cols-2 items-center border-gray-200">
                <label htmlFor="counter-Premium" className="text-left block text-m font-medium text-gray-700">
                  Premium
                </label>
                <div>
                  <div className="flex w-auto rounded-md shadow-sm">
                    <input
                      type="number"
                      defaultValue={bestSellOffer[0].price}
                      step="0.1"
                      pattern="/d+"
                      min="0.1"
                      max="0.9"
                      name="premium"
                      id="counter-price"
                      required="required"
                      onChange={handleChange}
                      className="block w-auto min-w-0 flex-1 bg-white text-center text-black font-bold rounded-md  border-black ring-indigo-500 sm:text-sm"
                    />
                  </div>
                </div>
                <label htmlFor="numberOfContracts" className="pt-1 text-left block text-m font-medium text-gray-700">
                  Number of Contracts
                </label>
                <div>
                  <div className="flex w-auto rounded-md shadow-sm">
                    <input
                      type="number"
                      defaultValue="1"
                      step="1"
                      pattern="/d+"
                      min="1"
                      name="numberOfContracts"
                      id="countersellcontracts"
                      required="required"
                      onChange={handleChange}
                      className="block w-auto min-w-0 flex-1 bg-white text-center text-black font-bold rounded-md  border-black ring-indigo-500 sm:text-sm"
                    />
                  </div>
                </div>
              </div>
              <div className="items-center border-gray-200">
                <div className='w-max'>
                  {sellOdds.map(odds => {
                    return (
                      <h3 key={odds.id} className="pt-2 text-m font-medium text-gray-900"><em>Implied Odds = {odds[formValues.premium]}</em></h3>
                    )
                  })}
                  <h3 className="text-m font-medium text-gray-900"><em>Potential Profit = {((formValues.numberOfContracts * formValues.premium)).toFixed(2)} ICP</em></h3>
                  <h3 className="pb-2 text-m font-medium text-gray-900"><em>Implied Lockup = {totalPrice} ICP</em></h3>
                </div>
                <div>
                </div>
              </div>
            </div>
          </form>
          <div className="py-4 px-6">
            <button
              type="submit"
              
              className="w-full rounded-md border border-transparent bg-green-500 py-3 px-4 text-base font-medium text-white shadow-sm hover:bg-green-600"
            >
              LOCK IN COUNTER
            </button>
          </div>
        </div>
      </div>
    )
  }

}
